import hatsStore from "@/store/hatsStore";
import eventOutbox from "@/store/eventOutbox";
import { PERSISTED_QUERY_CACHE_KEY } from "@/queryClient";

// Per-user climber state that lives in web storage rather than on the server.
// A page reload does not clear it, so without this a reset leaves the climber
// experience half-cleared (hats still flagged as viewed, hat packs already
// revealed, one-time modals already dismissed).
//
// Auth tokens, the active user/product keys and the maintenance bypass are
// deliberately left alone — the coach stays logged in through a reset.
const LOCAL_STORAGE_KEYS = [PERSISTED_QUERY_CACHE_KEY];
const SESSION_STORAGE_KEYS = ["seenHatPackIds"];
const SESSION_STORAGE_PREFIXES = ["welcomeModalShown_"];

export const clearClimberClientStorage = () => {
  try {
    LOCAL_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
    SESSION_STORAGE_KEYS.forEach((key) => sessionStorage.removeItem(key));
    Object.keys(sessionStorage)
      .filter((key) =>
        SESSION_STORAGE_PREFIXES.some((prefix) => key.startsWith(prefix)),
      )
      .forEach((key) => sessionStorage.removeItem(key));
    // Clears the in-memory set and its VIEWED_HATS_V2_<userId> entry.
    hatsStore.clearViewed();
    // Unsent events outlive a reload now, so without this a reset would leave
    // pre-reset events able to re-award badges the reset just removed.
    eventOutbox.clear();
  } catch (error) {
    console.warn("Could not clear climber client storage", error);
  }
};
